module.exports = __webpack_public_path__ + "img/money-block.1c762d60.svg";